/* Measures app-injected banners fixed to the viewport and publishes their
   heights as --crtz-topbar / --crtz-bottombar for crtz-top-banner.css.

   The Essential Countdown Timer app can be set to top or bottom, injects after
   load, and is absent from the server HTML, so neither Liquid nor CSS can tell
   which. Measuring at runtime keeps both settings working with no theme edit.

   Published at every width; crtz-top-banner.css decides what to do with them. */
(function () {
  'use strict';

  var root = document.documentElement;
  var observer = null;

  /* Fixed only. A sticky bar sits in the flow, so the body padding we set to
     clear it would move it, changing the next measurement. */
  function isBanner(el) {
    if (el.nodeType !== 1) return false;
    var style = getComputedStyle(el);
    return style.position === 'fixed' &&
           style.visibility !== 'hidden' &&
           style.display !== 'none' &&
           el.getBoundingClientRect().width > window.innerWidth / 2;
  }

  /* Banners fixed to the top and bottom of the viewport, and the elements
     themselves so their heights can be watched.

     Only elements BEFORE the header count. On mobile the header is itself
     fixed and full width, so without this it measures as a banner and reports
     its own height. */
  function measure() {
    var header = document.getElementById('shopify-section-header');
    var top = 0;
    var bottom = 0;
    var elements = [];

    for (var i = 0; i < document.body.children.length; i++) {
      var el = document.body.children[i];
      if (el === header) break;
      if (!isBanner(el)) continue;

      var box = el.getBoundingClientRect();
      if (box.height < 1 || box.height > window.innerHeight / 2) continue;

      if (box.top <= 4) {
        top += box.height;
        elements.push(el);
      } else if (box.bottom >= window.innerHeight - 4) {
        bottom += box.height;
        elements.push(el);
      }
    }

    return { top: Math.round(top), bottom: Math.round(bottom), elements: elements };
  }

  /* Writing a variable reflows the page, which moves the banners being
     watched, which fires the observer again. Only write on a real change or
     the loop never settles. */
  function set(name, value) {
    if (root.style.getPropertyValue(name) === value) return;
    root.style.setProperty(name, value);
  }

  function apply() {
    var bars = measure();
    set('--crtz-topbar', bars.top + 'px');
    set('--crtz-bottombar', bars.bottom + 'px');

    /* A countdown changes height as it re-renders. */
    if (!window.ResizeObserver) return;
    if (observer) observer.disconnect();
    else observer = new ResizeObserver(update);
    bars.elements.forEach(function (el) { observer.observe(el); });
  }

  /* A throw here must not take the page with it: the CSS defaults both
     variables to 0, which is the layout as it was before this file. */
  function update() {
    try { apply(); } catch (e) {
      if (window.console) console.warn('crtz-top-banner:', e);
    }
  }

  update();
  window.addEventListener('load', update);
  window.addEventListener('resize', update);

  /* The app injects whenever its script runs, which can be long after us.
     childList only, so the countdown ticking every second is ignored. */
  if (window.MutationObserver) {
    new MutationObserver(update).observe(document.body, { childList: true });
  }
})();
